import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';

export interface IListagemOperacoes {
  idoperacoes: string;
  descricao: string;
  tipooperacao: string;
  pagamento: number;
  tpag: number;
  tipo: number;
  faturamento: boolean;
  status: boolean;
}
export interface IDetalheOperacoes {
  descricao: string;
  tipo: number;
  estoque: boolean;
  faturamento: boolean;
  status: boolean;
  tpag: number;
}
type TComTotalCount = {
    data: IListagemOperacoes[];
    totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (page = 1, filter = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/estoqueoperacoes?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHASSMALL),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllist = async (filter = '', id = '', tipo: number): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ? `/estoqueoperacoeslist?limit=${Environment.LIMITE_DE_LINHASSMALL}&filter=${filter}&tipo=${tipo}` : `/estoqueoperacoeslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHASSMALL),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IDetalheOperacoes | Error> => {
  try {
    const { data } = await Api.get(`/estoqueoperacoes/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheOperacoes): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheOperacoes>('/estoqueoperacoes',  {idoperacoes: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheOperacoes): Promise<void | Error> => {
  try {
    await Api.put(`/estoqueoperacoes/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/estoqueoperacoes/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const EstoqueOperacoesService = {
  getAll,
  getAlllist,
  create,
  getById,
  updateById,
  deleteById,
};